import { types, actions } from './requests'
export const GETWORKORDER_TYPES = {
    ...types('GETWORKORDER'),
}
export const GETWORKORDER_ACTIONS = {
    ...actions('GETWORKORDER'),
}